import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';
export const Container = _ref => {
  let {
    children,
    dataTest,
    className,
    height
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["3332822660", [height]]]) + " " + (className || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3332822660",
    dynamic: [height]
  }, ["div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;height:".concat(height, ";}")]));
};
Container.propTypes = {
  height: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string
};